<template>
  <div class="g-marker">
  </div>
</template>

<script>

export default {
  name: 'Marker',
  data () {
    return {
      marker: null,
    }
  },
  props: ['options', 'map'],
  methods: {
    add() {
      this.marker = new RichMarker({
        position: new google.maps.LatLng(this.options.lat, this.options.lng),
        map: this.map,
        flat: true,
        draggable: false,
        content: '<div class="loc-marker">'+
                    '<img src="'+this.getHost()+'/img/ic_marker'+this.getLocation(this.options)+'.png" >'+
                  '</div>'
      });
      this.marker.setMap(this.map);
      this.marker.addListener('click', (ev) => {
        this.$emit('click', ev);
      });
    },
    remove() {
      if (!this.marker) {
        return;
      } else {
        google.maps.event.clearListeners(this.marker, 'click');
        this.marker.setMap(null);
      }
    },
    getHost() {
      let host = window.location.host;
      if (host.indexOf('localhost') > -1) {
        return 'http://localhost:3000';
      } else {
        return '';
      }
    },
    getLocation(firm) {
      let d = new Date();
      let weekday = d.getDay();
      let day;
      let current = ("0" + d.getHours()).slice(-2) + ("0" + d.getMinutes()).slice(-2)
      current = parseInt(current, 10);
      if (weekday === 0) {
        day = 7;
      } else {
        day = weekday;
      }
      if (current > parseInt(firm['opening_from_'+day]) && current < parseInt(firm['opening_to_'+day]) ) {
        return '_open';
      } else {
        return '';
      }
    }
  },
  created() {
    this.add();
  },
  destroyed() {
    this.remove();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .loc-marker {
    width: 30px;
  }
  .loc-marker img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Marker.vue